import { Draft } from 'immer';
import { getType } from 'typesafe-actions';

import {
    AddCreativeAction,
    applyCropSuccess,
    applyPreviewsSelect,
    changeSize,
    checkSize,
    initCommonCreativeSuccess,
    togglePreview
} from '../actions';
import { selectCommonCreativeState } from '../selectors';
import { AddCreativeState } from '../typings';

import { getModalPreviewItemsAfterCrop } from './helpers';

export function processAddCommonCreative(draft: Draft<AddCreativeState>, action: AddCreativeAction): void {
    switch (action.type) {
        case getType(togglePreview): {
            const commonCreativeState = selectCommonCreativeState(draft);
            const { ids, val } = action;

            if (!commonCreativeState.previewItems) {
                return;
            }

            if (!ids.length) {
                commonCreativeState.previewItems.forEach(el => (el.selected = val));

                return;
            }

            const item = commonCreativeState.previewItems.find(el => el.id === ids[0]);

            if (item) {
                item.selected = val;
            }

            return;
        }

        case getType(applyPreviewsSelect): {
            const commonCreativeState = selectCommonCreativeState(draft);

            commonCreativeState.previewsModalVisible = false;

            const { items, previewItems } = commonCreativeState;

            if (!items || !previewItems) {
                return;
            }

            items.forEach((item, index) => (item.selected = previewItems[index].selected));
            commonCreativeState.previewItems = undefined;

            return;
        }

        case getType(checkSize): {
            const commonCreativeState = selectCommonCreativeState(draft);
            const { value } = action;

            if (!commonCreativeState.items) {
                return;
            }

            const item = commonCreativeState.items.find(el => el.id === value);

            if (item) {
                item.selected = !item.selected;
            }

            return;
        }

        case getType(changeSize): {
            const commonCreativeState = selectCommonCreativeState(draft);
            const { value } = action;

            commonCreativeState.currentId = value;

            return;
        }

        case getType(initCommonCreativeSuccess): {
            const commonCreativeState = selectCommonCreativeState(draft);
            const { result } = action;

            commonCreativeState.creativeOptions = result.options;
            commonCreativeState.items = result.items;
            commonCreativeState.bundle = result.bundle;
            // по дефолту выбираем первый размер в списке
            commonCreativeState.currentId = result.items[0].id;

            if (result.presetId !== undefined) {
                commonCreativeState.presetId = result.presetId;
            }

            if (result.isIdea) {
                commonCreativeState.ideaFilesCropped = false;
            }

            if (result.batchId !== undefined) {
                commonCreativeState.id = result.batchId;
            }

            return;
        }

        case getType(applyCropSuccess): {
            const commonCreativeState = selectCommonCreativeState(draft);
            const { response, editedSizes } = action;

            commonCreativeState.previewsModalVisible = true;
            commonCreativeState.previewItems = getModalPreviewItemsAfterCrop(
                commonCreativeState,
                response.items,
                editedSizes
            );

            return;
        }

        default:
            return;
    }
}
